<div [class.disabled]="disable" [class.open]="select_open" class="select_list">
    <div #select_label (click)="select_open = !select_open" class="header">
        <span [innerHTML]="selectedValue ? '<b>' + selectedValue.name + '</b>' : 'SEARCH.NOT_SELECTED' | translate"></span>
        <i class="icon-down"></i>
    </div>
    <div #select_body *ngIf="select_open" [@fade]="'in'" class="list">
        <label (click)="select(item)" *ngFor="let item of row; let i = index">
            <input name="select_map" type="radio" value="{{item.id}}">
            <span [class.selected]="selectedValue && selectedValue.id === item.id">{{ item.name }}</span>
        </label>
    </div>
</div>
